export function scenarioSpeedReducer(scenarioSpeed, action) {
    if (scenarioSpeed === void 0) { scenarioSpeed = 1; }
    switch (action.type) {
        case 'UPDATE_RECEIVED':
            if (action.message.type === 'scenarioSpeed') {
                return action.message.payload;
            }
    }
    return scenarioSpeed;
}



//////////////////
// WEBPACK FOOTER
// ./src/components/VehicleController/reducers.ts
// module id = 1832
// module chunks = 0